import React, { useState, useEffect } from 'react'; // --- FIX: Removed unused 'use' import
import { useAuth } from '../context/AuthContext';
import './Comments.css';
import { db } from '../firebaseConfig'; // Make sure this path is correct

// --- FIX: Added updateDoc and arrayUnion for replies/reactions ---
import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
  serverTimestamp,
  orderBy,
  doc,
  deleteDoc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";


const Comments = ({ countryName }) => {
  const { currentUser, users } = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [replyingTo, setReplyingTo] = useState(null); // Tracks which comment ID is being replied to
  const [replyText, setReplyText] = useState('');
  const [reactingTo, setReactingTo] = useState(null); // Tracks which comment ID is being reacted to

  const availableEmojis = ['👍', '❤', '😂', '😮', '😢', '😡'];

  const autoResize = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  useEffect(() => {
    // Stop if countryName isn't loaded yet
    if (!countryName) return; 

    const commentsQuery = query(
      collection(db, "comments"), 
      where("countryName", "==", countryName), 
      orderBy("timestamp", "asc")
    );
    
    const unsubscribe = onSnapshot(commentsQuery, (querySnapshot) => {
      const fetchedComments = [];
      querySnapshot.forEach((doc) => {
        fetchedComments.push({ ...doc.data(), id: doc.id }); // Keep using doc.id
      });
      setComments(fetchedComments);
    });

    return () => unsubscribe();
  }, [countryName]);

  const handleAddComment = async () => {
    if (!newComment.trim() || !currentUser) return;

    try {
      await addDoc(collection(db, "comments"), {
        user: currentUser.email,
        text: newComment,
        timestamp: serverTimestamp(),
        replies: [],
        reactions: {},
        countryName: countryName
      });
      setNewComment('');
    } catch (error) {
      console.error("Error adding comment: ", error);
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const commentDocRef = doc(db, "comments", commentId);
      await deleteDoc(commentDocRef);
    } catch (error) {
      console.error("Error deleting comment: ", error);
    }
  };

  // --- FIX: This function is now connected to Firestore ---
  const handleAddReply = async (parentCommentId) => {
    if (!replyText.trim() || !currentUser) return;

    // Note: We use new Date() here because serverTimestamp()
    // cannot be used inside an arrayUnion.
    const newReply = {
      user: currentUser.email,
      text: replyText,
      timestamp: new Date() // Firestore will convert this to a Timestamp
    };

    try {
      const commentDocRef = doc(db, "comments", parentCommentId);
      await updateDoc(commentDocRef, {
        replies: arrayUnion(newReply) // Atomically adds the new reply to the array
      });

      setReplyText('');
      setReplyingTo(null);
    } catch (error) {
      console.error("Error adding reply: ", error);
    }
  };

  // --- FIX: This function is now connected to Firestore ---
  const handleReaction = async (commentId, emoji) => {
    if (!currentUser) return;

    // Find the comment in our local state to get its current reactions
    const comment = comments.find(c => c.id === commentId);
    if (!comment) return;

    const userEmail = currentUser.email;
    const newReactions = { ...(comment.reactions || {}) };
    const userPreviousReaction = Object.keys(newReactions).find(e => newReactions[e].includes(userEmail));

    // This is your excellent logic, unchanged!
    if (userPreviousReaction === emoji) {
      newReactions[emoji] = newReactions[emoji].filter(email => email !== userEmail);
      if (newReactions[emoji].length === 0) {
        delete newReactions[emoji];
      }
    } else {
      if (userPreviousReaction) {
        newReactions[userPreviousReaction] = newReactions[userPreviousReaction].filter(email => email !== userEmail);
        if (newReactions[userPreviousReaction].length === 0) {
          delete newReactions[userPreviousReaction];
        }
      }
      const existingReactionUsers = newReactions[emoji] || [];
      newReactions[emoji] = [...existingReactionUsers, userEmail];
    }
    
    // Now, update the document in Firestore
    try {
      const commentDocRef = doc(db, "comments", commentId);
      await updateDoc(commentDocRef, {
        reactions: newReactions
      });

      setReactingTo(null); // Close emoji picker
    } catch (error) {
      console.error("Error handling reaction: ", error);
    }
  };

  // Helper function to safely format timestamp
  const formatTimestamp = (fbTimestamp) => {
    if (!fbTimestamp) return "Just now";
    // Check if it's a Firestore timestamp (has .toDate()) or a JS Date
    const date = fbTimestamp.toDate ? fbTimestamp.toDate() : new Date(fbTimestamp);
    return date.toLocaleString();
  };

  return (
    <div className="comments-section">
      <h3>Comments</h3>
      {currentUser && (
        <div className="comment-input">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onInput={autoResize}
            placeholder="Add a comment..."
            rows="1"
          />
          <button onClick={handleAddComment}>Post Comment</button>
        </div>
      )}
      <div className="comments-list">
        {comments.length === 0 ? (
          <p>No comments yet. Be the first to comment!</p>
        ) : (
          comments.map((comment) => { // --- FIX: Removed 'index'
            const author = users.find(u => u.email === comment.user);
            const authorName = author ? author.firstName : comment.user;
            const authorPhoto = author ? author.profilePhoto : null;
            const authorUsername = author ? author.username : null;

            return (
              // --- FIX: Use comment.id for the key ---
              <div key={comment.id} className="comment">
                <div className="comment-header">
                  {authorPhoto ? (
                    <img src={authorPhoto} alt="User" className="comment-user-photo" />
                  ) : (
                    <div className="comment-user-initial">
                      {authorUsername ? authorUsername.charAt(0).toUpperCase() : ''}
                    </div>
                  )}
                  <p className="comment-user">{authorName}</p>
                </div>
                <p className="comment-text">{comment.text}</p>
                <div className="comment-footer">
                    {/* --- FIX: Use helper function for timestamp --- */}
                    <p className="comment-timestamp">{formatTimestamp(comment.timestamp)}</p>
                    <div className="comment-actions">
                      {currentUser && (
                        <>
                          {/* --- FIX: Use comment.id for state --- */}
                          <button onClick={() => setReactingTo(comment.id)} className="comment-react-button">
                            React
                          </button>
                          <button onClick={() => setReplyingTo(comment.id)} className="comment-reply-button">
                            Reply
                          </button>
                        </>
                      )}
                      {currentUser && currentUser.email === comment.user && (
                          <button onClick={() => handleDeleteComment(comment.id)} className="comment-delete-button">
                              Delete
                          </button>
                      )}
                    </div>
                </div>

                {/* --- FIX: Compare with comment.id --- */}
                {replyingTo === comment.id && (
                  <div className="reply-form">
                    <textarea
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                      onInput={autoResize}
                      placeholder="Write a reply..."
                      rows="1"
                    />
                    {/* --- FIX: Pass comment.id --- */}
                    <button onClick={() => handleAddReply(comment.id)}>Submit Reply</button>
                    <button onClick={() => setReplyingTo(null)} className="cancel-reply-button">Cancel</button>
                  </div>
                )}

                {/* Render Replies */}
                {comment.replies && comment.replies.length > 0 && (
                  <div className="replies-section">
                    {comment.replies.map((reply, replyIndex) => {
                      const replyAuthor = users.find(u => u.email === reply.user);
                      const replyAuthorName = replyAuthor ? replyAuthor.firstName : reply.user;
                      const replyAuthorPhoto = replyAuthor ? replyAuthor.profilePhoto : null;
                      const replyAuthorUsername = replyAuthor ? replyAuthor.username : null;

                      return (
                        <div key={replyIndex} className="comment reply">
                          <div className="comment-header">
                            {replyAuthorPhoto ? (
                              <img src={replyAuthorPhoto} alt="User" className="comment-user-photo" />
                            ) : (
                              <div className="comment-user-initial">
                                {replyAuthorUsername ? replyAuthorUsername.charAt(0).toUpperCase() : ''}
                              </div>
                            )}
                            <p className="comment-user">{replyAuthorName}</p>
                          </div>
                          <p className="comment-text">{reply.text}</p>
                          <div className="comment-footer">
                            {/* --- FIX: Use helper function for timestamp --- */}
                            <p className="comment-timestamp">{formatTimestamp(reply.timestamp)}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* --- FIX: Compare with comment.id --- */}
                {reactingTo === comment.id && (
                  <div className="emoji-picker">
                    {availableEmojis.map(emoji => (
                      <span key={emoji} onClick={() => handleReaction(comment.id, emoji)}>
                        {emoji}
                      </span>
                    ))}
                  </div>
                )}

                {/* Display Reactions */}
                {comment.reactions && Object.keys(comment.reactions).length > 0 && (
                  <div className="comment-reactions">
                    {Object.entries(comment.reactions).map(([emoji, users]) => 
                      users.length > 0 ? (
                        <div key={emoji} className="reaction-tag">
                          {emoji} {users.length}
                        </div>
                      ) : null
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Comments;